module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-up-right-76ab27cbacb27b02e1aaefc6061c50e6.svg";